// Copyright (c) 2016 Deere & Company

const decimalFormats = [
    'EMPTY',
    'X',
    'Y'
];

export default decimalFormats;



// WEBPACK FOOTER //
// ./src/shared/utils/decimal-formats.js